import { addressLineFields } from '../constants'
import { getAddressFieldValue } from '../helpers'

const getLinePart = (address, field) => ({ field, value: getAddressFieldValue(address, field, 'name') })

const getLineParts = (address, fields) => fields.map(field => getLinePart(address, field)).filter(part => part.value)

const getLineKey = parts => parts.map(part => part.field).join('-')

export const getAddressLines = address => {
  return addressLineFields
    .map(fields => getLineParts(address, fields))
    .filter(parts => parts.length > 0)
    .map(parts => ({ key: getLineKey(parts), parts }))
}
